// templateMapper.ts
import type { IThemePageInfo } from '~/types/themePage';
import type { IThemePage } from '~/stores/themePage';

import {
  getDefaultThumbnail,
  mapTemplateInfoV6,
  mapTemplateInfoV7,
  parseLabelTemplate,
  parseTemplateInfoBy,
} from './templateHandler';
import { checkTemplateDefaultOnGP } from '~/modules/asset-template/helpers';
import { ProviderSource, TemplateType } from '~/types/template';

export const mapThemePageInfo = (
  templateSuffix?: string,
  themePages?: IThemePage[],
  isCheckDefault = true,
): IThemePageInfo | undefined => {
  const templateInfo = parseTemplateInfoBy({
    templateSuffix,
    themePages: isCheckDefault ? themePages : undefined,
  });
  if (!templateInfo) return;

  const { providerSource, type } = templateInfo;

  const isDefaultByShopify = providerSource === ProviderSource.SHOPIFY_ORIGIN;
  const dataDefault: IThemePageInfo = {
    templateInfo,
    label: parseLabelTemplate(templateInfo),
    thumbnail: getDefaultThumbnail(providerSource),
    default: isDefaultByShopify,
    providerSource: providerSource!,
    isChildren: false,
  };

  if (!templateSuffix) return dataDefault;

  const isTemplateBackup = providerSource === ProviderSource.SHOPIFY_GP_BACKUP;
  const isBaseTemplateOfGPDefault = checkTemplateDefaultOnGP(themePages, templateSuffix);
  const isHomeTemplate = type === TemplateType.HOME;

  if (isHomeTemplate && (isTemplateBackup || isBaseTemplateOfGPDefault)) {
    return {
      ...dataDefault,
      isHide: true,
    };
  }

  if (providerSource === ProviderSource.GEMPAGESV7) {
    const data = mapTemplateInfoV7(templateSuffix, themePages, isCheckDefault);

    if (!data) {
      return {
        ...dataDefault,
        isHide: true,
      };
    }

    return data;
  }

  if (providerSource === ProviderSource.GEMPAGESV6) {
    const data = mapTemplateInfoV6(templateSuffix, themePages);

    if (!data) {
      return {
        ...dataDefault,
        isHide: true,
      };
    }

    return data;
  }

  return dataDefault;
};
